import { 
  Box, 
  Container, 
  Typography, 
  Grid, 
  Card, 
  CardContent,
  Chip,
  Stack,
  Button,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tab,
  Tabs
} from '@mui/material';
import {
  Article as NewsIcon,
  Dashboard as DashboardIcon,
  Widgets as WidgetIcon,
  Payment as PaymentIcon,
  Gavel as LegalIcon,
  Security as SecurityIcon,
  Speed as SpeedIcon,
  Palette as PaletteIcon,
  CheckCircle as CheckIcon,
  ExpandMore as ExpandIcon,
  TrendingUp as TrendingIcon,
  SmartToy as BotIcon,
  Language as GlobalIcon,
  Analytics as AnalyticsIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
  Article
} from '@mui/icons-material';
import { useState } from 'react';

const FeaturesPage = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [hoveredCard, setHoveredCard] = useState(null);

  // Ana Özellik Kategorileri
  const mainFeatures = [
    {
      icon: <NewsIcon sx={{ fontSize: 50 }} />,
      title: "Haber Yönetimi Sistemi",
      subtitle: "Profesyonel İçerik Yönetimi",
      description: "Word gibi kolay editör, çoklu medya desteği, haber havuzu ve editör onay sistemi ile profesyonel haber yönetimi",
      color: "#1e40af",
      gradient: "linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)",
      features: [
        "Gelişmiş WYSIWYG editör",
        "Çoklu medya desteği (resim, video, galeri)",
        "Haber havuzu sistemi",
        "Kategori ve etiket yönetimi",
        "Yorum yönetimi ve moderasyon",
        "Manşet ve sıralama yönetimi",
        "Yayın tarihi planlama",
        "Haber onay iş akışı (editör onayı)",
        "Çoklu yazar desteği"
      ]
    },
    {
      icon: <WidgetIcon sx={{ fontSize: 50 }} />,
      title: "70+ Widget Kütüphanesi",
      subtitle: "Sürükle-Bırak Sayfa Tasarımcısı",
      description: "Manşet, haber listeleri, finans, hava durumu, spor ve daha fazlası. Kod bilgisi gerektirmeden görsel arayüzle tasarlayın",
      color: "#dc2626",
      gradient: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
      features: [
        "10+ Manşet widget varyasyonu",
        "30+ Haber listesi stili",
        "Finans widget'ları (döviz, altın, kripto)",
        "Hava durumu widget'ları",
        "Spor widget'ları (lig, maç, skor)",
        "Yazar/Köşe yazarı widget'ları",
        "Reklam yönetimi widget'ları",
        "Sosyal medya entegrasyonu"
      ]
    },
    {
      icon: <PeopleIcon sx={{ fontSize: 50 }} />,
      title: "Rol Tabanlı Yetkilendirme",
      subtitle: "Güvenli Kullanıcı Yönetimi",
      description: "Yönetici, editör, yazar, muhabir ve üye rolleri ile granüler izin sistemi. Her kullanıcı sadece yetkisi olanları görsün",
      color: "#059669",
      gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)",
      features: [
        "Yöneticiler - Tam sistem yetkisi",
        "Editörler - İçerik onaylama ve düzenleme",
        "Yazarlar - İçerik oluşturma",
        "Muhabirler - Haber girişi ve fotoğraf",
        "Üyeler - Yorum ve etkileşim",
        "Granüler izin sistemi",
        "Modül bazlı erişim kontrolü",
        "Kullanıcı aktivite logları"
      ]
    },
    {
      icon: <PaymentIcon sx={{ fontSize: 50 }} />,
      title: "Abonelik Sistemi",
      subtitle: "Sürdürülebilir Gelir Modeli",
      description: "Okuyucularınızdan gelir elde edin. Farklı paket seçenekleri, premium içerik kilitleme ve güvenli ödeme altyapısı",
      color: "#7c3aed",
      gradient: "linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%)",
      features: [
        "Çoklu abonelik paketleri",
        "Premium içerik kilitleme sistemi",
        "Güvenli ödeme entegrasyonu",
        "Abone davranış analitiği",
        "Otomatik fatura oluşturma",
        "Abonelik raporları",
        "E-posta bildirimleri",
        "Üyelik yönetimi"
      ]
    },
    {
      icon: <LegalIcon sx={{ fontSize: 50 }} />,
      title: "BİK Uyumlu İlan Sistemi",
      subtitle: "Resmi İlan Yayını ve Gelir",
      description: "Basın İlan Kurumu standartlarına %100 uyumlu. Resmi ilan yönetimi, arşivleme ve raporlama. Ek gelir kaynağı",
      color: "#ea580c",
      gradient: "linear-gradient(135deg, #ea580c 0%, #f97316 100%)",
      features: [
        "BİK standartları ve güvenlik",
        "Resmi ilan kategorilendirme",
        "Yasal arşivleme ve saklama",
        "İlan gelir raporları",
        "Otomatik ilan onayı",
        "İlan arama sistemi",
        "PDF ilan yükleme",
        "İlan yayın takibi"
      ]
    },
    {
      icon: <SpeedIcon sx={{ fontSize: 50 }} />,
      title: "Yüksek Performans",
      subtitle: "Hızlı Yükleme, Mutlu Okuyucular",
      description: "1 saniyenin altında sayfa yükleme. Otomatik görsel optimizasyonu, CDN desteği ve SEO uyumlu yapı",
      color: "#0891b2",
      gradient: "linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)",
      features: [
        "1 saniyenin altında yükleme",
        "Otomatik görsel optimizasyonu",
        "CDN desteği",
        "SEO uyumlu yapı",
        "Otomatik sitemap",
        "Meta tag yönetimi",
        "Open Graph desteği",
        "Schema.org yapısal veri"
      ]
    }
  ];

  // Widget Kategorileri
  const widgetCategories = [
    {
      category: "Manşet Widget'ları",
      count: "10+",
      items: [
        "Slider manşet widget'ları (6 farklı stil)",
        "Video manşet widget'ları",
        "Tam ekran hero widget'lar",
        "Otomatik geçiş ve manuel kontrol"
      ]
    },
    {
      category: "Haber Listeleme",
      count: "30+",
      items: [
        "Grid layout'lar (2x1, 3x1, 3x2, 3x4, 4x4)",
        "Liste görünümleri (dikey, yatay, kompakt)",
        "Kart tasarımları (modern, klasik, magazin)",
        "Timeline ve kronolojik görünümler",
        "Masonry (Pinterest tarzı) layout",
        "Ticker ve kayan haber bantları"
      ]
    },
    {
      category: "Finans Widget'ları",
      count: "8+",
      items: [
        "Döviz kurları (3 varyasyon)",
        "Altın fiyatları",
        "Kripto para (2 varyasyon)",
        "Borsa widget'ları",
        "Kayan finans ticker"
      ]
    },
    {
      category: "Hava Durumu",
      count: "4+",
      items: [
        "4 farklı tasarım seçeneği",
        "Şehir bazlı hava durumu",
        "5 günlük tahmin",
        "Detaylı meteoroloji bilgisi"
      ]
    },
    {
      category: "Spor Widget'ları",
      count: "4+",
      items: [
        "Lig tablosu widget",
        "Maç sonuçları widget",
        "Spor ticker widget",
        "Canlı skor desteği"
      ]
    },
    {
      category: "Genel Widget'lar",
      count: "20+",
      items: [
        "Newsletter/Bülten widget",
        "Trend haberler",
        "Popüler haberler",
        "Sosyal medya feed",
        "Arama widget",
        "Etiket bulutu",
        "Reklam yönetimi"
      ]
    }
  ];

  // İçerik Türleri
  const contentTypes = [
    { icon: <NewsIcon />, title: "Haberler", description: "Güncel haber yönetimi" },
    { icon: <Article />, title: "E-Gazete", description: "Dijital gazete yayını" },
    { icon: <DashboardIcon />, title: "Foto Galeri", description: "Görsel içerik yönetimi" },
    { icon: <Article />, title: "Köşe Yazıları", description: "Yazar profilleri ve yazıları" },
    { icon: <NewsIcon />, title: "Duyurular", description: "Önemli duyurular" },
    { icon: <PeopleIcon />, title: "Biyografiler", description: "Kişi profilleri" }
  ];

  // Teknik Özellikler
  const technicalFeatures = [
    {
      icon: <BotIcon />,
      title: "Otomatik Ajans Botları",
      description: "RSS feed okuyucu, haber ajansı entegrasyonu ve otomatik içerik çekme"
    },
    {
      icon: <GlobalIcon />,
      title: "Çok Dilli Destek",
      description: "Türkçe ve İngilizce hazır, kolayca yeni dil eklenebilir"
    },
    {
      icon: <SecurityIcon />,
      title: "Banka Seviyesinde Güvenlik",
      description: "Şifreli bağlantı, otomatik yedekleme ve DDoS koruması"
    },
    {
      icon: <AnalyticsIcon />,
      title: "Detaylı Analitik",
      description: "Hangi haber ne kadar okunuyor? Tüm veriler grafiklerle"
    }
  ];

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          py: { xs: 10, md: 16 },
          background: `
            linear-gradient(
              135deg,
              #ffffff 0%,
              #f8fafc 25%,
              #f1f5f9 50%,
              #e2e8f0 75%,
              #cbd5e1 100%
            )
          `,
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
              radial-gradient(circle at 20% 20%, rgba(30, 64, 175, 0.05) 0%, transparent 50%),
              radial-gradient(circle at 80% 80%, rgba(220, 38, 38, 0.05) 0%, transparent 50%)
            `,
            pointerEvents: 'none'
          }
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ textAlign: 'center', mb: 10 }}>
            <Typography
              variant="overline"
              sx={{
                fontSize: '0.9rem',
                fontWeight: 900,
                letterSpacing: '0.1em',
                color: '#1e40af',
                mb: 2,
                display: 'block',
                textTransform: 'uppercase'
              }}
            >
              ÖZELLİKLER
            </Typography>

            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '2.5rem', md: '4.5rem' },
                fontWeight: 800,
                mb: 4,
                background: 'linear-gradient(135deg, #1e293b 0%, #1e40af 50%, #dc2626 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                lineHeight: 1.1
              }}
            >
              Profesyonel Haber Platformu
            </Typography>

            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: '1.2rem', md: '1.5rem' },
                color: '#64748b',
                maxWidth: 800,
                mx: 'auto',
                lineHeight: 1.6,
                fontWeight: 400,
                mb: 6
              }}
            >
              70+ widget, güçlü admin panel, abonelik sistemi ve BİK uyumluluğu ile 
              haber sitenizi yönetmek için ihtiyacınız olan her şey
            </Typography>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
              <Button
                variant="contained"
                size="large"
                sx={{
                  background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                  color: 'white',
                  px: 4,
                  py: 2,
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  textTransform: 'none',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 10px 30px rgba(30, 64, 175, 0.3)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Ücretsiz Demo Talep Et
              </Button>
              <Button
                variant="outlined"
                size="large"
                sx={{
                  borderColor: '#1e40af',
                  color: '#1e40af',
                  px: 4,
                  py: 2,
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  borderWidth: 2,
                  textTransform: 'none',
                  '&:hover': {
                    borderWidth: 2,
                    borderColor: '#1e3a8a',
                    background: 'rgba(30, 64, 175, 0.05)',
                    transform: 'translateY(-2px)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Fiyatlandırmayı Gör
              </Button>
            </Stack>
          </Box>
        </Container>
      </Box>

      {/* Ana Özellikler Grid */}
      <Box sx={{ py: { xs: 10, md: 16 }, background: 'white' }}>
        <Container maxWidth="xl">
          <Grid container spacing={4}>
            {mainFeatures.map((feature, index) => (
              <Grid item xs={12} md={6} lg={4} key={index}>
                <Paper
                  elevation={0}
                  onMouseEnter={() => setHoveredCard(index)}
                  onMouseLeave={() => setHoveredCard(null)}
                  sx={{
                    p: 5,
                    height: '100%',
                    background: '#ffffff',
                    border: '1px solid #e2e8f0',
                    borderRadius: 4,
                    position: 'relative',
                    cursor: 'pointer',
                    transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    overflow: 'hidden',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      height: 4,
                      background: feature.gradient,
                      transform: hoveredCard === index ? 'scaleX(1)' : 'scaleX(0)',
                      transformOrigin: 'left',
                      transition: 'transform 0.3s ease'
                    },
                    '&:hover': {
                      transform: 'translateY(-8px) scale(1.02)',
                      boxShadow: `0 20px 40px ${feature.color}20, 0 10px 20px rgba(0, 0, 0, 0.1)`,
                      borderColor: feature.color
                    }
                  }}
                >
                  {/* Icon */}
                  <Box
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 80,
                      height: 80,
                      borderRadius: 3,
                      background: `${feature.color}15`,
                      color: feature.color,
                      mb: 3,
                      transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                      transform: hoveredCard === index ? 'scale(1.1) rotate(5deg)' : 'scale(1)'
                    }}
                  >
                    {feature.icon}
                  </Box>

                  {/* Title */}
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      mb: 1,
                      color: '#1e293b',
                      fontSize: '1.5rem',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif'
                    }}
                  >
                    {feature.title}
                  </Typography>

                  {/* Subtitle */}
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 500,
                      mb: 3,
                      background: feature.gradient,
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      fontSize: '1.1rem'
                    }}
                  >
                    {feature.subtitle}
                  </Typography>

                  {/* Description */}
                  <Typography
                    variant="body1"
                    sx={{
                      color: '#64748b',
                      lineHeight: 1.7,
                      mb: 4,
                      fontSize: '1rem'
                    }}
                  >
                    {feature.description}
                  </Typography>

                  {/* Feature List */}
                  <List dense sx={{ mb: 2 }}>
                    {feature.features.slice(0, 5).map((item, idx) => (
                      <ListItem key={idx} sx={{ px: 0, py: 0.5 }}>
                        <ListItemIcon sx={{ minWidth: 32 }}>
                          <CheckIcon sx={{ color: feature.color, fontSize: 20 }} />
                        </ListItemIcon>
                        <ListItemText 
                          primary={item}
                          primaryTypographyProps={{
                            fontSize: '0.95rem',
                            color: '#475569',
                            fontWeight: 500
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>

                  {feature.features.length > 5 && (
                    <Typography
                      variant="body2"
                      sx={{
                        color: feature.color,
                        fontWeight: 600,
                        fontSize: '0.9rem'
                      }}
                    >
                      +{feature.features.length - 5} özellik daha
                    </Typography>
                  )}
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Widget Galerisi */}
      <Box 
        sx={{ 
          py: { xs: 10, md: 16 },
          background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
          color: 'white'
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ textAlign: 'center', mb: 10 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                mb: 3,
                color: 'white'
              }}
            >
              70+ Hazır Widget Kütüphanesi
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: 'rgba(255,255,255,0.8)',
                maxWidth: 700,
                mx: 'auto',
                lineHeight: 1.6
              }}
            >
              Manşet'ten finans'a, hava durumu'ndan spor'a kadar her şey hazır. 
              Sürükle-bırak ile istediğiniz gibi yerleştirin
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {widgetCategories.map((category, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    background: 'rgba(255, 255, 255, 0.05)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: 3,
                    p: 3,
                    height: '100%',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      background: 'rgba(255, 255, 255, 0.08)',
                      transform: 'translateY(-5px)',
                      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: 'white', flex: 1 }}>
                      {category.category}
                    </Typography>
                    <Chip 
                      label={category.count}
                      size="small"
                      sx={{
                        background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                        color: 'white',
                        fontWeight: 600
                      }}
                    />
                  </Box>
                  <List dense>
                    {category.items.map((item, idx) => (
                      <ListItem key={idx} sx={{ px: 0, py: 0.5 }}>
                        <ListItemIcon sx={{ minWidth: 28 }}>
                          <CheckIcon sx={{ color: '#3b82f6', fontSize: 18 }} />
                        </ListItemIcon>
                        <ListItemText 
                          primary={item}
                          primaryTypographyProps={{
                            fontSize: '0.9rem',
                            color: 'rgba(255,255,255,0.9)'
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CTA Section */}
      <Box
        sx={{
          py: { xs: 10, md: 16 },
          background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
          color: 'white',
          textAlign: 'center'
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              fontWeight: 800,
              mb: 3
            }}
          >
            Hemen Başlayın
          </Typography>
          <Typography
            variant="h6"
            sx={{
              mb: 6,
              opacity: 0.95,
              lineHeight: 1.6,
              maxWidth: 600,
              mx: 'auto'
            }}
          >
            Tüm bu güçlü özellikleri deneyimlemeye başlamak için sadece bir tık uzaktasınız. 
            30 gün ücretsiz deneyin, kredi kartı gerekmez
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} justifyContent="center">
            <Button
              variant="contained"
              size="large"
              sx={{
                background: 'white',
                color: '#1e40af',
                px: 6,
                py: 2.5,
                fontSize: '1.1rem',
                fontWeight: 700,
                borderRadius: 2,
                textTransform: 'none',
                '&:hover': {
                  background: '#f8fafc',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              30 Gün Ücretsiz Deneyin
            </Button>
            <Button
              variant="outlined"
              size="large"
              sx={{
                borderColor: 'white',
                color: 'white',
                px: 6,
                py: 2.5,
                fontSize: '1.1rem',
                fontWeight: 600,
                borderRadius: 2,
                borderWidth: 2,
                textTransform: 'none',
                '&:hover': {
                  borderWidth: 2,
                  background: 'rgba(255, 255, 255, 0.1)',
                  transform: 'translateY(-2px)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Canlı Demo İzle
            </Button>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default FeaturesPage;

